<template>
  <v-card class="pa-6 d-flex flex-column">
    <div v-if="! editing" class="d-flex flex-column gap-4">
      <div class="d-flex hovervisible-activator">
        <div :title="$t('MANAGE.OWNER')" class="d-flex align-center">
          <user-avatar v-if="owner" :user="owner" :size="32" show-username class="mr-2"></user-avatar>
        </div>
        <v-btn-icon v-if="userIsProjectAdmin" size="x-small" class="ml-2 hovervisible-item export-hidden" @click="editing = 'owner'">
          <v-icon>far fa-pencil-alt</v-icon>
        </v-btn-icon>
      </div>

      <div>
        <project-sheet-thumbnail :planning="planning" class="mr-2 mb-2 float-left" @update:editing="editing = 'thumbnail'">
        </project-sheet-thumbnail>
        <project-sheet-category :planning="planning" @update:editing="editing = 'category'">
        </project-sheet-category>
      </div>
    </div>
    <div v-else>
      <manage-change-owner v-if="editing == 'owner'" :project="{ id: planning.id, owner_id: owner.id }" class="text-center"
                           @change-owner="onChangeOwner">
      </manage-change-owner>
      <project-sheet-thumbnail v-if="editing == 'thumbnail'" editing :planning="planning" class="mx-auto"
                               @update:editing="editing = null">
      </project-sheet-thumbnail>
      <project-sheet-category v-if="editing == 'category'" editing :planning="planning"
                              @update:editing="editing = null">
      </project-sheet-category>
      <div style="position: absolute; top: 4px; right: 4px" class="export-hidden">
        <v-btn-icon size="x-small" @click="editing = null">
          <v-icon>far fa-times</v-icon>
        </v-btn-icon>
      </div>
    </div>
  </v-card>
</template>

<script>
  import ManageChangeOwner from '@/components/Manage/partials/ManageChangeOwner.vue';
  import ProjectSheetThumbnail from './ProjectSheetThumbnail.vue';
  import ProjectSheetCategory from './ProjectSheetCategory.vue';
  import useUsersStore from '@/stores/users';

  export default {
    components: {
      ManageChangeOwner,
      ProjectSheetThumbnail,
      ProjectSheetCategory,
    },
    props: {
      planning: { type: Object, required: true },
      closeEditing: { type: Boolean, default: false },
    },
    data() {
      return {
        editing: null,
        usersStore: useUsersStore(),
      };
    },
    computed: {
      owner() {
        return this.usersStore.getUserById(this.planning.meta.owner_id);
      },
      userIsProjectAdmin() {
        return this.planning.meta.access_right == 'admin';
      },
    },
    watch: {
      closeEditing(newVal) {
        if (newVal) this.editing = null;
      },
    },
    methods: {
      onChangeOwner() {
        window.location.reload();
      },
    },
  };
</script>
